export default () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect
      x='3'
      y='3'
      width='14'
      height='14'
      rx='2'
      stroke='#5A607F'
      strokeWidth='1.5'
    />
    <path
      d='M6 6.5L7.5 8L10 5.5'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 10.5L7.5 12L10 9.5'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6 14.5L7.5 16L10 13.5'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
